import type { IconProps } from '../types/IconProps.ts';
export const PenLine: IconProps = {
    name: 'PenLine',
    children: [
        `<g clip-path="url(#a)">`,
        `<path d="m8.21 20.06 12.9-13.65a2.74 2.74 0 1 0-3.97-3.76L4.19 16.35a1 1 0 0 0-.19.28l-2.27 5.03a.5.5 0 0 0 .63.67l5.47-2.01a1 1 0 0 0 .38-.26M12 21h9" />`,
        `</g>`,
        `<defs>`,
        `<clipPath id="a">`,
        `<path d="M0 0h24v24H0z" />`,
        `</clipPath>`,
        `</defs>`,
    ]
};